// eslint-disable-next-line no-shadow
export enum IMedicalCertificateTypes {
  MEDICAL_CERTIFICATE_GET_REQUEST = '@request/MEDICAL_CERTIFICATE_GET_REQUEST',
  MEDICAL_CERTIFICATE_GET_SUCCESS = '@request/MEDICAL_CERTIFICATE_GET_SUCCESS',
  MEDICAL_CERTIFICATE_GET_FAILURE = '@request/MEDICAL_CERTIFICATE_GET_FAILURE',
}

export interface IMedicalCertificateDocumento {
  id: number;
  nome: string;
  isComplemento: boolean;
}

export interface IMedicalCertificateHistoricoUnidade {
  nome: string;
  filialP12: string;
}

export interface IMedicalCertificateHistorico {
  id: number;
  tipoAcao: string;
  data: string;
  autor?: {
    nome: string;
    cargo: string;
  };
  mensagem?: string;
  complementoEnviado?: boolean;
  unidade?: IMedicalCertificateHistoricoUnidade;
  nomesDocumentoComplementar?: string[];
}

export interface IMedicalCertificate {
  id: string;
  status: string;
  dataSolicitacao: string;
  tipoOcorrencia: string;
  documentos: IMedicalCertificateDocumento[];
  historico: IMedicalCertificateHistorico[];
}

export interface IMedicalCertificateError {
  status?: number;
  message?: string;
}

export interface IMedicalCertificateState {
  readonly data: IMedicalCertificate[];
  readonly loading: boolean;
  readonly error: IMedicalCertificateError | null;
}
